import { type ReactNode } from 'react';

import classNames from '@/utils/classnames';

interface SidebarBrandProps {
  /** Glyph rendered inside the brand tile (e.g. a Phosphor icon). */
  icon: ReactNode;
  title: string;
  subtitle?: string;
  className?: string;
}

/**
 * Static brand block for a sidebar header (icon tile + title + subtitle).
 * Visually matches the WorkspaceSwitcher trigger; use it where there's nothing
 * to switch (e.g. the admin panel).
 */
export function SidebarBrand({ icon, title, subtitle, className }: SidebarBrandProps) {
  return (
    <div className={classNames('flex h-10 items-center gap-2.25 px-1.5', className)}>
      <div className="flex size-7 shrink-0 items-center justify-center rounded-tile bg-brand">{icon}</div>
      <div className="flex min-w-0 flex-1 flex-col gap-px">
        <span className="truncate font-mono text-sm font-semibold leading-tight text-fg">{title}</span>
        {subtitle && <span className="truncate text-2xs font-medium leading-tight text-fg-tertiary">{subtitle}</span>}
      </div>
    </div>
  );
}
